"use client";

import { createContext } from "react";

export const NonceContext = createContext<string | null>(null);
